import { render, staticRenderFns } from "./ResourcePreviewCard.vue?vue&type=template&id=b07b33ee&scoped=true"
import script from "./ResourcePreviewCard.vue?vue&type=script&lang=js"
export * from "./ResourcePreviewCard.vue?vue&type=script&lang=js"
import style0 from "./ResourcePreviewCard.vue?vue&type=style&index=0&id=b07b33ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07b33ee",
  null
  
)

export default component.exports